import React from 'react'
import styles from './LeftSidebar.scss'
import {CueList} from './CueList'
import {Distance, Elevation} from 'common/units'

export class LeftSidebar extends React.PureComponent {
  render () {
    const {route, cues, currentCue, cuePicked} = this.props

    const totalCues = cues.size
    const remainingCues = cues.filter(c => c.confirmed).size
    const percentCompleted = Math.floor(100 * remainingCues / totalCues)

    return (
      <div className={styles.LeftSidebar}>
        <div className={styles.routeInfo}>
          <div>
            {route.name}
          </div>
          <div>
            <Distance value={route.metrics.distance} />
            &nbsp;+<Elevation value={route.metrics.ele_gain} />
          </div>
          <div className={styles.metrics}>
            {percentCompleted}% completed ({remainingCues} / {totalCues} cues)
          </div>
        </div>
        <CueList cues={cues} currentCue={currentCue} cuePicked={cuePicked} />
      </div>
    )
  }
}
